(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-gallery"] && !window.DesignMode) return;
  try {
    
  let rowsShown = 1;
  let imagesShown = 6;
  document.getElementById('show-more-images').addEventListener('click', function () {
    let els = document.querySelectorAll('.gallery-container > div');
    els.forEach((element) => {
      element.classList.remove('hidden');
    });
    document.getElementById('show-more-images').classList.add('hidden');
    document.getElementById('show-less-images').classList.remove('hidden');
  });
  document.getElementById('show-less-images').addEventListener('click', function () {
    let els = document.querySelectorAll('.gallery-container > div:nth-child(n+8)');
    els.forEach((element) => {
      element.classList.add('hidden');
    });
    document.getElementById('show-more-images').classList.remove('hidden');
    document.getElementById('show-less-images').classList.add('hidden');
  });

  var modal = document.getElementById("gallery-modal");
  var galleryImages = document.querySelectorAll(".box__gallery");
  var span = document.getElementById("close");
  galleryImages.forEach((image) => {
    image.onclick = (el) => {
      document.querySelector('#gallery-modal .img-container').innerHTML = el.srcElement.outerHTML;
      modal.style.display = "block";
    }
  });
  span.onclick = function() {
    modal.style.display = "none";
  }
  window.onclick = function(event) {
    if (event.target == modal) {
      modal.style.display = "none";
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const innerHTML = new DOMParser()
                .parseFromString(text, 'text/html')
                .querySelector('product-recommendations');
            if ( innerHTML && innerHTML.querySelectorAll('.product-item').length > 0 ) {
              this.innerHTML = innerHTML.innerHTML;
              window.preloadImages(this);
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const innerHTML = new DOMParser()
                .parseFromString(text, 'text/html')
                .querySelector('product-recommendations');
            if ( innerHTML && innerHTML.querySelectorAll('.product-item').length > 0 ) {
              this.innerHTML = innerHTML.innerHTML;
              window.preloadImages(this);
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
